<template>
    <md-dialog-alert
            class="alertDialog"
            :md-active.sync="alertDialog.show"
            :md-title="alertDialog.title"
            :md-content="alertDialog.message" />
</template>

<script>
    import axios from 'axios'

    export default {
        name: "ApiCall",
        data: () => ({
            apiUrl: process.env.NODE_ENV === 'production'
                ? 'https://www.falk-huth.de/api/'
                : (process.env.NODE_ENV === 'test'
                        ? 'https://www.falk-huth.de/api/'
                        : 'http://localhost/falk-huth/api/'
                ),
            alertDialog: {
                show: false,
                title: '',
                message: ''
            },
            session: {
                apiKey: ''
            },
            responseStatus: null
        }),
        methods: {
            formatResponse: function (response) {
                var message = '<div>'
                message += '<p><b>Status: ' + response.status + '</b></p>'
                message += '<form class="alertForm"><textarea class="alertTextArea" name="alertJSON" cols="100%" rows="10">'
                message += JSON.stringify(response.data, null, 2)
                message += '</textarea></form>'
                message += '</div>'
                return message;
            },
            getFullApiUrl: function (route, params) {
                var apiRoute = this.apiUrl + "index.php?RESTurl=" + route;
                if (params && params !== "") {
                    apiRoute += "&" + params;
                }
                return apiRoute;
            },
            sendContactForm: async function(formData) {
                this.responseStatus = null
                await axios.post(
                    this.getFullApiUrl('contactForm'),
                    formData,
                    {
                        headers: { 'content-type': 'application/json' }
                    }
                ).then(response => {
                    this.responseStatus = response.status
                }, exception => {
                    this.alertDialog.title = "Fehler"
                    this.alertDialog.message = 'Fehler:\n' + exception === null ? "unbekannt" : exception.toString()
                    this.alertDialog.show = true
                });
            },
            //
            // OLD FUNCTIONS
            //
            testApiCall: function () {
                this.alertDialog.title = "Information"
                this.alertDialog.message = "Test abgesetzt"
                this.alertDialog.show = true
            },
            getSessionApiKey: async function () {
// eslint-disable-next-line
                console.log("getSessionApiKey")
                // Wert zurücksetzen
                this.session.apiKey = ""

                // Parameter
                var apiKey   = "D8166CC6-532E-4804-AFF5-E025DCF2875E"
                var apiRoute = "index.php?RESTurl=session&apiKey="
                /*

                    axios({method: "GET", "url": sessionUrl + apiKeyInit}).then(result => {
                        // this.pokemons = result.data.results;
                        // console.log(result.data.count);
                        console.log(result);
                    }, error => {
                        console.error(error);
                    });*/

                // GET request
                let response = await axios.get(this.apiUrl + apiRoute + apiKey);
                this.session.apiKey = response.data.apiKey
                /*
                await axios.get(apiUrl + apiKey)
                    .then(response => {
                        this.session.apiKey = response.data.apiKey
                        this.alertDialog.title = "Erfolg " + response.data.apiKey
                        this.alertDialog.message = this.formatResponse(response)
                        this.alertDialog.show = true
                    }, exception => {
                        this.alertDialog.title = "Fehler"
                        this.alertDialog.message = 'Fehler:\n' + exception === null ? "unbekannt" : exception.toString()
                        this.alertDialog.show = true
                    })
                    */

                // Performing a POST request
                /*
                axios.post('/save', { firstName: 'Marlon', lastName: 'Bernardes' })
                    .then(function(response){
                        console.log('saved successfully')
                    });
                    */

                /*
                axios({method: "GET", "url": sessionUrl + apiKeyParam}).then(result => {
                    this.confirmText = 'Test' // result;
                    this.confirmDialog = true
                }, error => {
                    this.alertText = error
                    this.alertDialog = true
                })
                */
// eslint-disable-next-line
                console.log(this.session.apiKey)
                return this.session.apiKey
            },
// eslint-disable-next-line
            sendContactMail: async function (formData) {

// eslint-disable-next-line
                console.log("sendContactMail")
                var apiKey = await this.getSessionApiKey()
// eslint-disable-next-line
                console.log("API-Key: " + apiKey)

                var apiRoute = "index.php?RESTurl=test&apiKey="
                /*

                    axios({method: "GET", "url": sessionUrl + apiKeyInit}).then(result => {
                        // this.pokemons = result.data.results;
                        // console.log(result.data.count);
                        console.log(result);
                    }, error => {
                        console.error(error);
                    });*/

                // GET request
                axios.get(this.apiUrl + apiRoute + apiKey)
                    .then(response => {
                        // apiKeyServer = response.apiKey
                        this.alertDialog.title = "Erfolg"
                        this.alertDialog.message = this.formatResponse(response)
                        this.alertDialog.show = true
                    }, exception => {
                        this.alertDialog.title = "Fehler"
                        this.alertDialog.message = 'Fehler:\n' + exception === null ? "unbekannt" : exception.toString()
                        this.alertDialog.show = true
                    })

                // Performing a POST request
                /*
                axios.post('/save', { firstName: 'Marlon', lastName: 'Bernardes' })
                    .then(function(response){
                        console.log('saved successfully')
                    });
                    */

                /*
                axios({method: "GET", "url": sessionUrl + apiKeyParam}).then(result => {
                    this.confirmText = 'Test' // result;
                    this.confirmDialog = true
                }, error => {
                    this.alertText = error
                    this.alertDialog = true
                })
                */
            }
        }
    }
    export function testApiCall() {
        // Backup function without component context
    }
</script>

<style lang="scss" scoped>
    .alertDialog, .md-dialog-container, .md-dialog-content {
        min-width: 80%;
        min-height: 50%;
        max-width: 100%;
        max-height: 100%;
        overflow: auto;
    }
    .alertForm, .alertTextArea {
        min-width: 100%;
        max-width: 100%;
        min-height: 100%;
        max-height: 100%;
    }
</style>
